module.exports = __webpack_public_path__ + "img/lg2.2dfc0d1d.jpg";